import { Lock } from 'lucide-react';
import { Button, type ButtonProps } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

/**
 * PermissionButton — ação negada não é ação escondida.
 *
 * Playbook § Acessibilidade: usuário sem permissão vê o controle desabilitado,
 * com cadeado e explicação em `title`/`aria-label`. O controle nunca some, para
 * o usuário entender que a ação existe e por que não pode executá-la.
 */
export function PermissionButton({
  permitido,
  motivo,
  children,
  ...props
}: ButtonProps & { permitido: boolean; motivo: string }) {
  if (permitido) return <Button {...props}>{children}</Button>;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        {/* O span mantém o tooltip acessível mesmo com o botão desabilitado. */}
        <span tabIndex={0} aria-label={motivo} className="inline-flex">
          <Button {...props} disabled aria-disabled="true" title={motivo} className="cursor-not-allowed">
            <Lock aria-hidden="true" />
            {children}
          </Button>
        </span>
      </TooltipTrigger>
      <TooltipContent>{motivo}</TooltipContent>
    </Tooltip>
  );
}
